import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { getSubscribers, updateSubscriptionStatus } from '../../api/admin/adminNewsLetter';

export const useSubscribers = () => {
  const {
    data: subscribers,
    isLoading,
    error,
    refetch
  } = useQuery('subscribers', getSubscribers, {
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to fetch subscribers');
    },
    staleTime: 300000, // 5 minutes
    cacheTime: 3600000, // 1 hour
  });

  return {
    subscribers,
    isLoading,
    error,
    refetchSubscribers: refetch
  };
};

export const useUpdateSubscription = () => {
  const queryClient = useQueryClient();

  const updateSubscriptionMutation = useMutation(updateSubscriptionStatus, {
    onSuccess: () => {
      toast.success("Subscription status updated successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      queryClient.invalidateQueries('subscribers');
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || 'Failed to update subscription status';
      toast.error(errorMessage);
    },
  });

  return updateSubscriptionMutation;
};
